// extracted by mini-css-extract-plugin
export var fullHeightState = "_1o-7";
export var headerCell = "_1o-1";
export var loadingStateCell = "_1o-4";
export var rowWrapper = "_1o-3";
export var standaloneTable = "_1o-8";
export var standaloneTableWithBodyFill = "_1o-9";
export var stateCell = "_1o-5";
export var table = "_1o-0";
export var tableBodyFiller = "_1o-6";
export var white = "_1o-2";